import { createApp } from "vue";

import "../../extension/src/assets/popup.css";
import ExtensionApp from "../../extension/src/App.vue";

createApp(ExtensionApp).mount("#app");

await import("../../extension/src/popup-controller.js");
